const config = require("config");

(function () {
  var controllerId = "searchController";
  angular
    .module("app")
    .controller(controllerId, ["$window","$scope", "$rootScope", "$http", "$q", "$timeout",
      "alkModalService", "_", "STATES", "alkGeocodeService", "routeService", "mapService",
      "LocationItem", "UserProvider", "GeoParser", "singleSearchService", "applicationSettingsService",
      "$document", "favoriteLocationsService",
      function searchController($window, $scope, $rootScope, $http, $q, $timeout,
        alkModalService, _, STATES, alkGeocodeService, routeService, mapService,
        LocationItem, userProvider, GeoParser, singleSearchService, applicationSettingsService,
        $document, favoriteLocationsService)
      {
        var vm = this;

        vm.opt = {
          region: userProvider.getUser().region,
          dataset: routeService.getDataset()
        };
        vm.title = "searchController";
        vm.mapId = "pcmMap";
        vm.userIsPremium = userProvider.getUser().isPremium();
        vm.userIsAdmin = userProvider.getUser().isAdmin();
        vm.isSingleSearch = !applicationSettingsService.getUserCfg("classicSearchView");
        vm.excludePOI = !applicationSettingsService.getUserCfg("includePOI");
        vm.isSearchVisible = true;
        vm.activeTab = 0;
        vm.hideClose = $scope.hideClose;
        vm.getActiveTab = function() {
          return vm.activeTab;
        };

        let lazyInitdValidAthenaCategories;
        function getValidAthenaCategories() {
          if (lazyInitdValidAthenaCategories === undefined) {
            // pchen: hard-coded Single-Search-friendly strings, one for each Athena place set
            const athenaCategories = [
              "CAT Scales",
              "Truck Services",
              "Manufacturing Plant",
              "Distribution Center",
              "Weigh Station",
              "Walmart Overnight Parking",
              "Intermodal Terminal",
              "LCV Lot"
            ];
            return singleSearchService.getValidPoiCategories()
              .then(validPoiCategories => {
                lazyInitdValidAthenaCategories = _.intersection(athenaCategories, validPoiCategories);
                return lazyInitdValidAthenaCategories;
              });
          } else {
            return $q.resolve(lazyInitdValidAthenaCategories);
          }
        }

        vm.focusClass = function (className) {
          if (routeService.getSelectedRoute() && routeService.getSelectedRoute().isCalculating) {
            return;
          }
          $timeout(function() {
            var inputs = $document[0].getElementsByClassName(className);
            for (var i = 0; i < inputs.length; i++) {
              inputs[i].focus();
            }
          });
        };

        vm.searchFocus = function () {
          if (userProvider.getUser().isPremium()) {
            vm.focusClass("search-address-input");
            vm.focusClass("single-search-input");
          } else {
            vm.focusClass("search-city-input");
          }
          vm.focusClass("favorite-filter-input");
          vm.focusClass("search-splc-input");
        };

        vm.labelText = function () {
          if ($scope.labelText) {
            return $scope.labelText;
          } else {
            return "";
          }
        };

        vm.labelClass = function () {
          return $scope.labelClass;
        };

        //two search boxes
        vm.searchCityString = "";
        vm.searchAddrString = "";

        vm.searchSplcString = "";

        vm.isSearching = false;

        vm.searchResults = [];
        vm.searchResultsVisibility = function () {
          return (vm.searchResults.length > 0 || vm.searchError !== "" || vm.isSearching);
        };
        vm.splcResults = [];
        vm.splcResultsVisibility = function () {
          return (vm.splcResults.length > 0 || vm.splcError !== "" || vm.isSearching);
        };

        vm.selectedLocation = null;

        vm.searchError = "";
        vm.splcError = "";

        vm.clearSearch = function () {
          vm.searchCityString = "";
          vm.searchAddrString = "";
          vm.searchResults = [];
          vm.searchError = "";
        };

        vm.clearSplc = function () {
          vm.searchSplcString = "";
          vm.searchResults = [];
          vm.splcError = "";
        };

        vm.searchClassic = function () {
          vm.searchResults = [];

          if (vm.searchCityString === "") {
            vm.searchError = "You must enter a city and/or zip/postal code";
            vm.focusClass("search-city-input");
            return;
          }

          vm.isSearching = true;
          vm.searchError = "";

          var querySearchString = vm.searchCityString;
          if (vm.searchAddrString != null && vm.searchAddrString !== "") {
            querySearchString = querySearchString + "; " + vm.searchAddrString;
          }

          var addrObj = {
            searchString: querySearchString,
            postcodefilter: "both" // we don't know if user is attempting to search Mexico or USA.  Send both.
          };
          var geoOpt = {
            listSize: 10,
            region: userProvider.getUser().region,
            dataset: routeService.getDataset()
          };
          alkGeocodeService.geocode(addrObj, geoOpt)
            .then(function (response) {
              if (response.length === 1) {
                if (response[0].Coords === null) {
                  vm.searchError = "No results found";
                } else {
                  response[0].origLatlon = null;
                  const selectedLocation = response[0];
                  // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
                  if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
                    var hasNegative = selectedLocation.Coords.Lat.includes("-");
                    var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 
                                                    : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
                    selectedLocation.Coords.Lat =   selectedLocation.Coords.Lat.substring(0, indexPosition)
                    + "." + selectedLocation.Coords.Lat.substring(indexPosition);
                  }
                  if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
                    var hasNegative = selectedLocation.Coords.Lon.includes("-");
                    var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 
                                                    : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
                    selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition)
                    + "." + selectedLocation.Coords.Lon.substring(indexPosition);
                  }
                  // Ends Temporary fix
                  vm.addStopToRoute(new LocationItem(selectedLocation));
                  //ga("send", "event", "Search", "Address", "Add Stop");
                }
              } else {
                vm.searchResults = processResults(response, "splc");
              }
            }, function (err) {
              if(geoOpt && geoOpt.dataset && geoOpt.dataset.toUpperCase() === "PCM18" && err.messages && err.messages.includes("Internal failure with requested version of PCMiler")) {
                vm.searchError = "Internal error from PCMiler 18, please consider using the latest PCMiler version.";
              } else {
                vm.searchError = "Couldn't recognize the input as a location";
              }
            })
            .finally(function () {
              vm.isSearching = false;
              vm.focusClass("csList0");
            });
        };

        vm.searchSplc = function () {
          vm.searchResults = [];

          if (!vm.searchSplcString) return;

          vm.isSearching = true;
          vm.splcError = "";

          var latlon = GeoParser.getLatLon(vm.searchSplcString);
          var geoOpt = {
            region: userProvider.getUser().region,
            dataset: routeService.getDataset()
          };
          // if the fields look like the format, "<lat>, <lon>", than do a reverse geocode on this lat/lon, otherwise search by splc
          if (latlon) {

            alkGeocodeService.reverseGeocode(latlon, geoOpt)
              .then(function (r) {
                var pr = processResults(r, "latlon");
                var selectedLocation = pr[0];
                // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
                if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
                  var hasNegative = selectedLocation.Coords.Lat.includes("-");
                  var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 
                                                  : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
                  selectedLocation.Coords.Lat =   selectedLocation.Coords.Lat.substring(0, indexPosition)
                  + "." + selectedLocation.Coords.Lat.substring(indexPosition);
                }
                if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
                  var hasNegative = selectedLocation.Coords.Lon.includes("-");
                  var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 
                                                  : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
                  selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition)
                  + "." + selectedLocation.Coords.Lon.substring(indexPosition);
                }
                // Ends Temporary fix
                selectLocation(selectedLocation, false);
              }, function (err) {
                vm.splcError = "No matching Latitude and Longitude";
              })
              .finally(function () {
                vm.isSearching = false;
              });

          } else {
            alkGeocodeService.geocode({
                splc: vm.searchSplcString
              }, geoOpt)
              .then(function (r) {
                if (r.length === 1) {
                  if (r[0].Coords === null) {
                    vm.splcError = "No matching SPLC found";
                  } else {
                    r[0].origLatlon = null;
                    const selectedLocation = r[0];
                    // Ref PCMWEB-1028 Temporarily we are converting the whole number coords to valid lat lon by adding the decimal points. For Lower data version, we are getting whole number as its coordinates
                    if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lat && !selectedLocation.Coords.Lat.includes(".")) {
                      var hasNegative = selectedLocation.Coords.Lat.includes("-");
                      var indexPosition = hasNegative ? selectedLocation.Coords.Lat.length > 9 ? 4 : 3 
                                                      : selectedLocation.Coords.Lat.length > 8 ? 3 : 2;
                      selectedLocation.Coords.Lat =   selectedLocation.Coords.Lat.substring(0, indexPosition)
                      + "." + selectedLocation.Coords.Lat.substring(indexPosition);
                    }
                    if(selectedLocation && selectedLocation.Coords && selectedLocation.Coords.Lon && !selectedLocation.Coords.Lon.includes(".")) {
                      var hasNegative = selectedLocation.Coords.Lon.includes("-");
                      var indexPosition = hasNegative ? selectedLocation.Coords.Lon.length > 9 ? 4 : 3 
                                                      : selectedLocation.Coords.Lon.length > 8 ? 3 : 2;
                      selectedLocation.Coords.Lon = selectedLocation.Coords.Lon.substring(0, indexPosition)
                      + "." + selectedLocation.Coords.Lon.substring(indexPosition);
                    }
                    // Ends Temporary fix
                    vm.addStopToRoute(new LocationItem(r[0]));
                    //ga("send", "event", "Search", "SPLC", "Add Stop");
                  }
                } else {
                  vm.splcResults = processResults(r, "splc");
                }
              }, function (err) {
                vm.splcError = "No matching SPLC found";
              })
              .finally(function () {
                vm.isSearching = false;
              });
          }
        };

        vm.singleSearchResults = [];

        vm.singleSearch = function () {

          // var centerLL = mapService.getMap().getCenter().transform(mapService.getMap().getProjectionObject(), new ALKMaps.Projection("EPSG:4326"));

          var searchStartCallback = function() {
            vm.isSearching = true;
          };

          var successCallback = function(results) {
            vm.singleSearchResults = processResults(results, "singlesearch");
            vm.isSearching = false;
            vm.focusClass("single-search-input"); //Re-focus so that if user was in the list and it changed, they don't lose focus on the page
          };

          var errorCallback = function(error) {
            console.log(error);
            vm.isSearching = false;
          };

          var searchParam = {
            query: vm.singleSearchString,
            maxResults: 10,
            countryType: "FIPS" // PCMWS's default country type is FIPS
            //currentLonLat: centerLL.lon + "," + centerLL.lat,
          };

          // custom place search is not available in Dev.
          if (config.env !== "Dev") {
            searchParam.useCustomPlaces = true;
            searchParam.customPlacesToken = userProvider.getUser().authToken;
          }

          if (vm.excludePOI) {
            getValidAthenaCategories()
              .then(validAthenaCategories => {
                _.extend(searchParam, {
                  poiCategories: validAthenaCategories.join(","),
                  excludedSearchTypes: "POIType"
                });
                singleSearchService.search(searchParam, searchStartCallback, successCallback, errorCallback);
              });
          } else {
            singleSearchService.search(searchParam, searchStartCallback, successCallback, errorCallback);
          }
        };

        function processResults(r, type) {
          var retVal = [];
          angular.forEach(r, function (value, key) { // jshint ignore:line
            if(type == "singlesearch" && value.ResultType == 14){
              value.origLatlon = vm.singleSearchString;
            } else if(type == 'latlon') { // splc
              value.origLatlon = vm.searchSplcString;
            } else { // or undefined type
              value.origLatlon = null;
            }
            var temp = new LocationItem(value);
            this.push(temp);
          }, retVal);
          return retVal;
        }

        function selectLocation(loc, pan) {
          vm.selectedLocation = loc;

          vm.showLocation(vm.selectedLocation, pan);

          vm.searchResults = [];
          vm.searchSplcString = "";
        }

        vm.showLocation = function (loc, pan) {
          vm.selectedLocation = loc;
          $rootScope.$broadcast("ShowPin", {location: loc, pan: pan, mapId: vm.mapId});
        };

        vm.locationClass = function (loc) {
          var className = "";

          if ((loc !== null) && (loc.Address.StreetAddress === "")) {
            className = "noAddress";
          }

          return className;
        };

        vm.addStopToRoute = function (loc) {
          $rootScope.$broadcast("AddStop", loc);
          vm.clearSearch();
          vm.searchFocus();
        };

        vm.hideSortableItem = function () {
          var index = Number($scope.sortableItemIndex);
          $rootScope.$broadcast("RemoveSortableItem", index);
        };

        vm.getFavorites = function() {
          return favoriteLocationsService.getAllLocations();
        };

        vm.hideFavorites = function () {
          vm.favorites = [];
        };

        vm.canSaveFavorite = function (loc) {
          return favoriteLocationsService.canSave(angular.copy(loc));
        };

        vm.deleteFavorite = function (fav) {
          alkModalService.show({
            size: "sm"
          },{
            headerText: "Delete Saved Location",
            bodyText: "Are you sure you want to delete this location?"
          }).then(() => {
            favoriteLocationsService.deleteFavorite(fav);
          });
        };

        vm.pickFavorite = function (fav) {
          $rootScope.$broadcast("SelectLocation", fav);
        };

        vm.addFavoriteToRoute = function (fav) {
          $rootScope.$broadcast("AddStop", angular.copy(fav));
        };

        vm.filterFunction = function (favorite) {
          if (!vm.favoriteFilter)
            return true;

          var regex = new RegExp(vm.favoriteFilter, "i");
          var name = favorite.Name;
          var cityStateZip = favorite.CityStateZip;
          var street = favorite.Address.StreetAddress;
          var matchResult = false;
          if (name == null && cityStateZip == null && street == null) {
            matchResult = false;
          } else if ((cityStateZip != null) && (cityStateZip.match(regex)) || ((name != null) && name.match(regex)) || ((street != null) && street.match(regex))) {
            matchResult = true;
          }
          return matchResult;
        };

        vm.focusInput = function (elemSelector) {
          $timeout(function () {
            angular.element(elemSelector).focus();
          }, 50);
        };

        vm.showMorePlaces = function () {
          alkModalService.show({
            size: "md",
            templateUrl: "/app/modal/placesDialog.template.html",
            controller: "placesController",
            controllerAs: "vm"
          }).then(function (result) {});
        };

        $scope.$on("MapClick", function (event, message) { // jshint ignore:line
          vm.clearSearch();
        });

        $scope.$on("SelectLocation", function (event, message) { // jshint ignore:line
          selectLocation(message, true);
        });

        $scope.$on("ShowLocation", function (event, message) { // jshint ignore:line
          selectLocation(message, true);
        });

        $scope.$on("FocusSearchField", function (event, message) { // jshint ignore:line
          vm.activeTab = 0;
          vm.searchFocus();
        });
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/search/search.controller.js